
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shaqvana",
      function () {
        return require("private-next-pages/shaqvana.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shaqvana"])
      });
    }
  